module.exports = __webpack_public_path__ + "img/booking-logo-old.86d1ecd9.svg";